// extracted by mini-css-extract-plugin
export default {"root":"style_root__5FwxY","embedded":"style_embedded__IkZA0","empty":"style_empty__f19ox","header":"style_header__INAKB","list":"style_list__rQedT"};